import type { SxProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import type { ReactNode, SyntheticEvent } from 'react';

const NoLineHeight = styled('span', { name: 'TableStopPropagation' })({
  lineHeight: 0,
});

type Event = 'onClick' | 'onMouseDown' | 'onMouseUp';

interface StopPropagationProps {
  children: ReactNode;
  events?: Event[];
  sx?: SxProps;
}

// TODO: This was copied from SAM for the table extraction. If another shared
// surface needs it, move it out to a generic shared UI StopPropagation component.
export const StopPropagation = ({
  children,
  events = ['onClick'],
  sx,
}: StopPropagationProps) => {
  const handlers = events.reduce(
    (acc, event) => {
      acc[event] = (e: SyntheticEvent) => e.stopPropagation();
      return acc;
    },
    {} as Record<Event, (e: SyntheticEvent) => void>
  );

  return (
    <NoLineHeight {...handlers} sx={sx}>
      {children}
    </NoLineHeight>
  );
};
